import { TopupInEligibleSVG } from '@svgComponents/TopupInEligibleSVG/TopupInEligibleSVG';
import { FormattedMessage } from 'react-intl';

import { MoneyWithDecimals } from '../../../ui/moneyWithDecimals';
import DashboardCTA from '../../dashboardComponents/DashboardCTA/DashboardCTA';

export const RepaymentsBeforeTopup = ({
    amountToRepayBeforeTopUp
}: {
    amountToRepayBeforeTopUp: number | undefined;
}) => {
    return (
        <DashboardCTA
            data-testid="drawdown-canTopUpAfterRepayments"
            title={
                <FormattedMessage
                    id="_.rbl_dashboard.loanEnded.createReapplyRequest"
                    defaultMessage="Request top up"
                />
            }
            // className={dashboardCtaStyles.nonBottomDashboardAction}
            icon={<TopupInEligibleSVG />}
            description={
                <FormattedMessage
                    id="_.rbl_dashboard.outstanding.amountToRepayBeforeTopupEligible"
                    defaultMessage="You’ll become eligible to request a top up once you’ve repaid {amountToRepayBeforeTopUp} – approval is subject to credit review"
                    values={{
                        amountToRepayBeforeTopUp: (
                            <strong>
                                <MoneyWithDecimals
                                    value={amountToRepayBeforeTopUp}
                                />
                            </strong>
                        )
                    }}
                />
            }
        />
    );
};
